//Carrier User Management API URL
export const URL_CARRIER_USERMANAGEMENT_API =
  "https://api.carrierappshub1.com/";

//Carrier User Management Application Names
export const UM_APP_NAME_DEV = "dPDR - (AWS - Dev)";
export const UM_APP_NAME_PROD = "dPDR - (AWS - Production)";

//dPDR Front end UI URLs, only used for User Management permissions
export const URL_UI_DEV = "https://dpdr-devui.carrier.com";
export const URL_UI_PROD = "https://dpdr-produi.carrier.com";

//dPDR Back end API URLs

// OVERRIDE API URL:
// Defaults to "" to indicate to use normal api selection logic.
// Set to a URL ONLY if you want to force the UI to point
// at a specific backend API.
export const URL_API_OVERRIDE = "";
//export const URL_API_OVERRIDE = "https://dpdr-dev.carrier.com/dpdr/";
//export const URL_API_OVERRIDE = "https://dpdr-devdiff.carrier.com/dpdr/";

// Locally running api
// Indicates to use proxy setting from package.json for locally running api
export const URL_API_LOCAL = "/";

// Dev API
export const URL_API_DEV = "https://dpdr-dev.carrier.com/dpdr/";

// Prod API
export const URL_API_PROD = "https://dpdr.carrier.com/dpdr/";
